import { z } from 'zod'

const numeric = (min: number, max: number) =>
  z.preprocess((value) => (typeof value === 'string' ? parseFloat(value) : value), z.number().min(min).max(max))

export const weatherQuerySchema = z.object({
  lat: numeric(-90, 90),
  lng: numeric(-180, 180),
  name: z.string().trim().min(1).optional()
})

export const routeWeatherQuerySchema = z.object({
  planId: z.string().min(1)
})

export const weatherComparisonSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
  dates: z.array(z.string().datetime()).min(1).max(7)
})

export type WeatherQuery = z.infer<typeof weatherQuerySchema>
export type RouteWeatherQuery = z.infer<typeof routeWeatherQuerySchema>
export type WeatherComparisonQuery = z.infer<typeof weatherComparisonSchema>
